module.exports = __webpack_public_path__ + "img/logo_blocks_rojo_azul.a386dbf6.png";